import { defineStore } from 'pinia'
import { ref, computed } from 'vue'
import { useStorage } from '@vueuse/core'

const STORAGE_KEY = 'executorWizard:selectItems'

const initialSelectItems = () => ({
	companies: null,
	drivers: null,
	cars: null,
	managers: null,
	trailers: null,
})

export const VIEW = {
	HUB: 'hub',
	CREATE_COMPANY: 'create-company',
	CREATE_MANAGER: 'create-manager',
	CREATE_DRIVER: 'create-driver',
	CREATE_CAR: 'create-car',
	CREATE_TRAILER: 'create-trailer',
}

export const MODEL_TO_VIEW = {
	companies: VIEW.CREATE_COMPANY,
	managers: VIEW.CREATE_MANAGER,
	drivers: VIEW.CREATE_DRIVER,
	cars: VIEW.CREATE_CAR,
	trailers: VIEW.CREATE_TRAILER,
}

export const useExecutorWizardStore = defineStore('executorWizard', () => {
	const selectItems = useStorage(
		STORAGE_KEY,
		initialSelectItems(),
		sessionStorage,
	)

	const activeView = ref(VIEW.HUB)

	const drafts = ref({})

	const lastCreatedId = ref(null)

	const isCompanyChosen = computed(() => !!selectItems.value.companies)

	const isValid = computed(() =>
		!!selectItems.value.companies &&
		!!selectItems.value.cars &&
		!!selectItems.value.drivers &&
		!!selectItems.value.managers
	)

	const carTrailerError = computed(() => {
		const car = selectItems.value.cars
		const trailer = selectItems.value.trailers
		if (car && trailer && car.id === trailer.id) {
			return 'Автомобиль и прицеп не могут быть одной записью'
		}
		return null
	})

	function setItem(model, value) {
		selectItems.value[model] = value
	}

	function setCompany(company) {
		selectItems.value.companies = company
		// NOTE: намеренно НЕ очищаем manager при смене компании —
		// менеджер может принадлежать нескольким компаниям (правка #5).
		// Фильтр по company_id в EntitySmartSearch обновится автоматически.
	}

	function clearItem(model) {
		selectItems.value[model] = null
	}

	function setView(view) {
		activeView.value = view
	}

	function backToHub() {
		activeView.value = VIEW.HUB
	}

	function saveDraft(model, data) {
		drafts.value[model] = data
	}

	function getDraft(model) {
		return drafts.value[model] || null
	}

	function clearDraft(model) {
		delete drafts.value[model]
	}

	function setLastCreated(id) {
		lastCreatedId.value = id
	}

	function reset() {
		selectItems.value = initialSelectItems()
		activeView.value = VIEW.HUB
		drafts.value = {}
		lastCreatedId.value = null
	}

	return {
		selectItems,
		activeView,
		drafts,
		lastCreatedId,
		isCompanyChosen,
		isValid,
		carTrailerError,
		setItem,
		setCompany,
		clearItem,
		setView,
		backToHub,
		saveDraft,
		getDraft,
		clearDraft,
		setLastCreated,
		reset,
	}
})
